import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Page from '../Page.js';
import PageContentWrapper from "../../components/PageContentWrapper.js";
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants.js';
import FormPartial from './FormPartial.js';
import Scheme from '../../models/Scheme.js';
import { getApi } from '../../api/endpoints.js';
import { toast } from 'react-toastify';

const New = (props) => {
  const navigate = useNavigate();
  const schemeObj = new Scheme();
  const [scheme, setScheme] = useState(schemeObj.toStateJson());
  const [createApi] = getApi('createScheme')

  const createRecord = async (params) => {
    try {
      await createApi(params).unwrap();
      navigate("/schemes")
      toast.success("Successfully Created.");
    } catch(error) {
      toast.error("Somethingwent wrong !");
      setScheme((prev_state) => {
        return {
          ...prev_state,
          errors: error.data.data.errors
        }
      })
    }
  }

  const handleSubmitFunction = () => {
    try{
      createRecord((new Scheme(scheme)).toApiJson());
    } catch(error){
      setScheme(new Scheme(scheme));
    }
  }

  const handleCancelFunction = () => {
    navigate('/schemes');
  }

  return (
    <Page
      uiPage={uiManager.getUiPage(PAGES.NewSchemePage.name)}
      breadcrumbs={[{ label: "Home", url: '/dashboard'}, { label: "Scheme List", url: '/schemes'}, { label: "Generate New Scheme" }]}
      className={'scheme-page'}
    >
      <PageContentWrapper contentHeading={"Generate New Scheme"}>
        <div className='m-3'>
          <div className='mb-4 col-md-12'>
            <form className="row g-3" autoComplete="off">
              <FormPartial scheme={scheme} setScheme={setScheme} />
              <div className='mb-4 col-md-12'>
                <div >
                  <button style={{ float: 'inline-start' }} type="button" className="btn btn-voltup-theme" onClick={handleCancelFunction}>Back</button>
                  <button type="button" className="btn btn-voltup-theme ms-3" onClick={handleSubmitFunction}>Create Scheme</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </PageContentWrapper>
    </Page>
  );

}

export default New;